import { LoginAction, UserD } from "../components/LoginForm/types";
export const SET_USER = "SET_USER";
export const RESET_STATE = "RESET_STATE";

export const setUser = (user: LoginAction) => {
  return {
    type: SET_USER,
    value: user,
  };
};

export const resetState = () => {
  return {
    type: RESET_STATE,
  };
};
